import styled from 'styled-components'

export const PaddingRight = styled.div`
    padding-right: 5px;

    @media screen and (max-width: 767px) {
        padding-right: 0;
    }
`

export const PaddingLeft = styled.div`
    padding-left: 5px;
    display: flex;
    justify-content: flex-end;
`